// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"462":"56ac77777ac47614","735":"4be63a2b82bd420c","882":"e6d8bda366d4ab69"}[chunkId] + ".js";
};